import ReactGA from "react-ga4";

type EventTrackerData = {
  category: string;
};

const trackingID = window.env.GOOGLE_ANALYTICS_ID;

if (trackingID) {
  ReactGA.initialize(trackingID);
}

export const eventTracker = (action: string, data: EventTrackerData): void => {
  if (trackingID && data) {
    ReactGA.event({
      action,
      category: data.category,
    });
  }
};
